export const Endpoint = 'users/set-own-timezone';
export const Method = 'POST';
